import React from 'react'
import { Choose } from 'react-extras'

import { Button } from 'antd'
import Auxiliary from 'util/Auxiliary'
import CustomScrollbars from 'util/CustomScrollbars'

import { getMessage } from '../../util/IntlMessages'
import NotificationItem from './NotificationItem'
import './notificationItem.css'
import { request, api } from '../../util/handlerRequestUtil'
import './appNotification.css'

const AppNotification = ({ notifications, hide, handleLoadMore }) => {
  function loadMore() {
    handleLoadMore()
  }

  async function onClickItem(item) {
    if (item !== null && item.id !== null) {
      hide()
      await request(api.getNotifications(item.id), true)
    }
  }

  function renderLoadMore() {
    return (
      <div className="load-more-wrap">
        <Button className="load-more-button" onClick={loadMore}>
          {getMessage('loadMore')}
        </Button>
      </div>
    )
  }

  return (
    <Auxiliary>
      <div>
        <h3 className="notification-title">{getMessage('notifications')}</h3>
      </div>

      <Choose>
        <Choose.When
          condition={notifications !== null && Array.isArray(notifications.items) && notifications.items.length > 0}
        >
          <CustomScrollbars className="gx-popover-scroll">
            <ul className="gx-sub-popover">
              {notifications.items.map((notification) => (
                <NotificationItem key={notification.id} notification={notification} onClick={onClickItem} />
              ))}
              {renderLoadMore()}
            </ul>
          </CustomScrollbars>
        </Choose.When>
      </Choose>
    </Auxiliary>
  )
}

export default AppNotification
